import { NgModule } from '@angular/core';
import {
  NbButtonModule,
  NbCardModule,
  NbProgressBarModule,
  NbTabsetModule,
  NbUserModule,
  NbIconModule,
  NbSelectModule,
  NbListModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormsModule } from '@angular/forms';
import { ThemeModule } from '../../../@theme/theme.module';
import { ChartModule } from 'angular2-chartjs';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';  
import { InvCasgregComponent } from './inv-casgreg/inv-casgreg.component'; 
import { InvoicingComponent } from './invoicing.component';
import { CardPayComponent } from './card-pay/card-pay.component';  



@NgModule({
  imports: [
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbIconModule,
    NbTabsetModule,
    NbSelectModule,
    NbListModule,
    ChartModule,
    NbProgressBarModule,
    NgxEchartsModule,
    NgxChartsModule,
    LeafletModule,
    FormsModule 
  ],
  declarations: [  
    InvoicingComponent,
    InvCasgregComponent,
    CardPayComponent,
  ],
  providers: [
    //AppointmentService
  ],
  exports: [
    InvCasgregComponent, 
  ]
})
export class InvoicingModule {

 }